import { z } from 'zod';

export const driverSchema = z.object({
  customerNumber: z.string().optional(),
  driversLicenceNumber: z.string(),
  dateOfBirth: z.date().optional(),
  licenceExpiryDate: z.date().optional(),
  driversLicenceClass: z.string(),
  driversLicenceJurisdiction: z.string(),
  endorsementsRestrictions: z.string().array().optional(),
  firstName: z.string(),
  middleName: z.string(),
  lastName: z.string(),
  addressLine1: z.string(),
  addressLine2: z.string().optional(),
  city: z.string(),
  jurisdiction: z.string(),
  country: z.string(),
  postalCode: z.string(),
});

export type DriverFormValues = z.infer<typeof driverSchema>;
export type DriverFormContext = DeepPartial<DriverFormValues>;
